module.exports = __webpack_public_path__ + "img/laptop_daños.4283fa42.svg";